.gantt-pin-rows {
  position: sticky;
  top: 0;
  z-index: 3 !important;
}

.gantt-pin-rows th {
  background: var(--fallback-b1, oklch(var(--b1)));
}

.gantt-pin-cols {
  position: sticky;
  left: 0;
  z-index: 2 !important;
  background: var(--fallback-b1, oklch(var(--b1)));
  border: none !important;
}

.gantt-pin-rows.gantt-pin-cols {
  z-index: 4 !important;
  background: var(--fallback-b1, oklch(var(--b1)));
}

.gantt-group-header td,
.gantt-group-header .gantt-pin-cols {
  background: color-mix(
    in srgb,
    var(--fallback-b1, oklch(var(--b1))),
    white 6%
  ) !important;
}

table {
  border-collapse: separate;
  border-spacing: 0;
}

.current-time-indicator {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 8px;
  z-index: 2;
  pointer-events: auto;
  cursor: pointer;
  overflow: hidden;
  margin-left: -3px;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  background: rgba(255, 255, 255, 0.15);
  background-clip: content-box;
}

.easter-egg-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  text-align: center;
  pointer-events: none;
  animation: ee-container 5s ease-in-out forwards;
}

.easter-egg-message .line1 {
  font-size: 22px;
  font-weight: 300;
  color: white;
  letter-spacing: 1px;
  font-family: Georgia, "Times New Roman", serif;
  opacity: 0;
  animation: ee-in 1s ease-out 0.2s forwards;
}

.easter-egg-message .line2 {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 14px;
  letter-spacing: 0.5px;
  font-family: Georgia, "Times New Roman", serif;
  font-style: italic;
  line-height: 1.6;
  opacity: 0;
  animation: ee-in 1s ease-out 0.8s forwards;
}

.easter-egg-message .line3 {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.35);
  margin-top: 24px;
  font-family: Georgia, "Times New Roman", serif;
  opacity: 0;
  animation: ee-in 1s ease-out 1.6s forwards;
}

@keyframes ee-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes ee-container {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  55% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  65% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.02);
  }

  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1);
  }
}

.easter-egg-message.dispersing .line1,
.easter-egg-message.dispersing .line2,
.easter-egg-message.dispersing .line3 {
  display: inline-flex;
  gap: 0;
}

.easter-egg-message.dispersing .char {
  display: inline-block;
  animation: particle-fly 1.2s ease-out forwards;
}

@keyframes particle-fly {
  0% {
    opacity: 1;
    transform: translate(0, 0) scale(1) rotate(0deg);
  }

  100% {
    opacity: 0;
    transform: translate(var(--tx), var(--ty)) scale(0.3) rotate(var(--tr));
  }
}

.current-time-indicator::before {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    transparent 0%,
    transparent 40%,
    rgba(255, 255, 255, 0.3) 48%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0.3) 52%,
    transparent 60%,
    transparent 100%
  );
  animation: time-wave 1s linear infinite;
}

@keyframes time-wave {
  0% {
    transform: translateY(-50%);
  }

  100% {
    transform: translateY(50%);
  }
}

.gantt-row:hover .gantt-pin-cols {
  background: var(--fallback-b2, oklch(var(--b2) / 0.5));
}

.time-cell {
  transition: background-color 0.15s ease;
}

.time-cell:hover {
  background: oklch(var(--p) / 0.06);
}
